import { createFileRoute, Link } from '@tanstack/react-router';

import { RunSheetsWorkspace } from '../../features/run-sheets/run-sheets-workspace';

export const Route = createFileRoute('/run_sheets/')({
  staticData: {
    permissionSection: 'catalog',
    breadcrumb: 'Run Sheets',
    layout: 'full-height',
  },
  component: RunSheetsPage,
});

function RunSheetsPage() {
  return (
    <RunSheetsWorkspace
      section="catalog"
      renderProductLabel={(product) => {
        const showKeySubheading = product.product_key !== product.product_name;
        return (
          <Link
            to="/products/$productId"
            params={{ productId: product.product_id }}
            search={{ tab: 'run-sheet' }}
            className="flex min-w-0 flex-col leading-tight hover:underline focus-visible:underline"
            title={product.product_name}
          >
            <span className="truncate text-sm font-medium">{product.product_name}</span>
            {showKeySubheading && (
              <span className="text-muted-foreground truncate font-mono text-[10px]">
                {product.product_key}
              </span>
            )}
          </Link>
        );
      }}
    />
  );
}
